import pdf from '../../assets/pdf.svg';
import gif from '../../assets/gif.svg';
import jpg from '../../assets/jpg.svg';
import png from '../../assets/png.svg';
import defaultIcon from '../../assets/defFile.svg';

export const getFileTypeIcon = (type) => {
  switch (type) {
    case 'application/pdf':
      return pdf;
    case 'image/gif':
      return gif;
    case 'image/jpeg':
    case 'image/jpg':
      return jpg;
    case 'image/tiff':
    case 'image/png':
      return png;
    default:
      return defaultIcon;
  }
};